'use client';

import {
  DesignSystemProviderAppDirectory,
  SvgGradients,
} from '@ironhack/design-system2/components';
import { type PropsWithChildren } from 'react';

import featureToggles from '@/config/feature-toggles';
import { AbTastyProvider } from '@/contexts/ab-tasty-context';
import { CookiebotContextProvider } from '@/contexts/cookiebot-context';
import { FeatureToggleProvider } from '@/contexts/feature-toggle';

type Props = PropsWithChildren;

export const ProviderWrapper = ({ children }: Props) => (
  <FeatureToggleProvider enabledFeatures={featureToggles}>
    <AbTastyProvider>
      <DesignSystemProviderAppDirectory>
        <CookiebotContextProvider>
          {children}
          <SvgGradients />
        </CookiebotContextProvider>
      </DesignSystemProviderAppDirectory>
    </AbTastyProvider>
  </FeatureToggleProvider>
);
